import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

export const useFetchData = (
  callbackApi,
  pageSize,
  optional1 = null,
  optional2 = null
) => {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [updatedData, setUpdatedData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [pageNum, setPageNum] = useState(1);
  const [prevPageNum, setprevPageNum] = useState(0);
  const [optionalParam1, setOptionalParam1] = useState(optional1);
  const [optionalParam2, setOptionalParam2] = useState(optional2);
  useEffect(() => {
    if (pageNum !== prevPageNum) {
      setLoading(true);
      //need some update here
      dispatch(
        callbackApi(
          searchQuery,
          pageNum,
          pageSize,
          setData,
          setUpdatedData,
          setTotalRows,
          optionalParam1,
          optionalParam2
        )
      ).then(() => {
        setLoading(false);
      });
      setprevPageNum(pageNum);
    }
  }, [
    dispatch,
    pageNum,
    prevPageNum,
    pageSize,
    searchQuery,
    callbackApi,
    optionalParam1,
    optionalParam2,
  ]);
  const handleCurrentPage = () => {
    setPageNum((prevPageNum) => prevPageNum + 1);
  };

  const handleSearchQuery = (val) => {
    setLoading(true);
    setData([]);
    setUpdatedData([]);
    setprevPageNum(0);
    setPageNum(1);
    setSearchQuery(val);
  };

  const handleSetOptionalParams = (param1, param2) => {
    setOptionalParam1(param1);
    setOptionalParam2(param2);
    handleSearchQuery("");
  };

  return {
    data,
    setData,
    updatedData,
    setUpdatedData,
    loading,
    totalRows,
    searchQuery,
    handleCurrentPage,
    handleSearchQuery,
    handleSetOptionalParams,
  };
};
